<digi-progress-bar></digi-progress-bar>
<router-outlet></router-outlet>
